import React from "react";

export default function AfriMedLandingShell({
  title,
  subtitle,
  subtitleClassName = "",
  children,
  contentClassName = "",
}) {
  return (
    <div className="auth-bg min-h-[100dvh] w-full text-[rgb(var(--clr-on-surface))]">
      <div className="afrimed-rail afrimed-rail--comfortable grid min-h-[100dvh] place-items-center py-10">
        <main className={["w-full max-w-[390px] text-center", contentClassName].join(" ").trim()}>
          <img
            src="/assets/images/afrimed_logo_stack.svg"
            alt="AfriMed™"
            className="mx-auto h-auto w-[160px]"
            draggable="false"
          />

          {title ? (
            <h1 className="mt-8 text-title-large text-[rgb(var(--clr-on-surface))]">
              {title}
            </h1>
          ) : null}

          {subtitle ? (
            <p
              className={[
                "mx-auto mt-3 max-w-[330px] text-body-large text-[rgb(var(--clr-on-surface-variant))]",
                subtitleClassName,
              ].join(" ").trim()}
            >
              {subtitle}
            </p>
          ) : null}

          {children ? <div className="mt-8 text-left">{children}</div> : null}
        </main>
      </div>
    </div>
  );
}
